import React, { PureComponent } from 'react'
import ContainerWithTitle from '../../HOC/ContainerWithTitle'
import {TaxesPage} from "../../../components/MfeParcels/TaxesPage";
import {connect} from "react-redux";

class TaxesContainer extends PureComponent {
    constructor(props) {
        super(props)
    }

    render() {
        const { flagReducer = {} } = this.props
        const { isTaxPageEnabled } = flagReducer
        return (isTaxPageEnabled &&
            <TaxesPage
                handleError={(error) => {
                    console.log(error)
                }}
            />
        )
    }
}

const TaxesPageWithTitle = ContainerWithTitle(TaxesContainer, 'Taxes (New)')

export default connect((state) => ({
    flagReducer: state.flagReducer,
}))(TaxesPageWithTitle)


// WEBPACK FOOTER //
// ./src/containers/Settings/Company/TaxesMFE.js